import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import VisibilityAnimation from '../VisibilityAnimation';
import FocusManager from '../FocusManager';
import OnClickOutside from '../OnClickOutside';
import { POINTS_Y, POINTS_X } from '../constants/overlay';
import { withStyles } from '../theme';
import { isolateMixin } from '../utils/mixins';
import createGetMemoizedRef from '../utils/createGetMemoizedRef';
var ARROW_SIZE = 5;

var styles = function styles(theme) {
  return {
    dropdown: {
      extend: isolateMixin,
      fontFamily: theme.fontFamily,
      borderRadius: theme.dropdown.borderRadius,
      boxSizing: 'border-box',
      opacity: 0.01,
      pointerEvents: 'none',
      position: 'relative',
      transitionDuration: "".concat(theme.dropdown.animationDuration, "ms"),
      transitionProperty: 'opacity, top',
      background: theme.dropdown.colors.background,
      outline: 'none',
      boxShadow: theme.dropdown.boxShadow
    },
    'pointY-bottom': {
      top: -10
    },
    'pointY-top': {
      top: 10
    },
    'pointX-left': {},
    'pointX-center': {},
    'pointX-right': {},
    isVisible: {
      opacity: 1,
      pointerEvents: 'auto',
      top: 0
    },
    withArrow: {
      '&:before': {
        position: 'absolute',
        border: "".concat(ARROW_SIZE, "px solid transparent"),
        pointerEvents: 'none'
      },
      '&$pointY-top:before': {
        content: '""',
        top: -ARROW_SIZE,
        borderTopWidth: 0,
        borderBottomColor: theme.dropdown.colors.border
      },
      '&$pointY-bottom:before': {
        content: '""',
        bottom: -ARROW_SIZE,
        borderBottomWidth: 0,
        borderTopColor: theme.dropdown.colors.border
      },
      '&$pointX-left:before': {
        left: 15
      },
      '&$pointX-center:before': {
        left: "calc(50% - ".concat(ARROW_SIZE, "px)")
      },
      '&$pointX-right:before': {
        right: 15
      }
    }
  };
};

var DropdownContent = /*#__PURE__*/function (_PureComponent) {
  _inherits(DropdownContent, _PureComponent);

  var _super = _createSuper(DropdownContent);

  function DropdownContent() {
    var _this;

    _classCallCheck(this, DropdownContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.onClickOutside = function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      if (props.isVisible) if (props.onRequestClose) props.onRequestClose();else props.hide();
    };

    _this.getMemoizedRef = createGetMemoizedRef();

    _this.renderContent = function (componentRef) {
      var _this$props = _this.props,
          isVisible = _this$props.isVisible,
          children = _this$props.children,
          anchorWidth = _this$props.anchorWidth,
          anchorFullWidth = _this$props.anchorFullWidth,
          className = _this$props.className,
          style = _this$props.style,
          theme = _this$props.theme,
          classes = _this$props.classes,
          padding = _this$props.padding,
          tabIndex = _this$props.tabIndex,
          contentRef = _this$props.contentRef,
          onBecomeVisible = _this$props.onBecomeVisible,
          onBecomeInvisible = _this$props.onBecomeInvisible,
          pointX = _this$props.pointX,
          pointY = _this$props.pointY,
          showArrow = _this$props.showArrow;
      var resultStyle = {};
      if (anchorWidth && anchorFullWidth) resultStyle.width = anchorWidth + 'px';
      if (padding) resultStyle.padding = padding;
      resultStyle = _extends({}, resultStyle, {}, style);
      return React.createElement(VisibilityAnimation, {
        isVisible: isVisible,
        animationDuration: theme.dropdown.animationDuration,
        onVisible: onBecomeVisible,
        onInvisible: onBecomeInvisible
      }, function (_ref) {
        var isVisible = _ref.isVisible;
        return React.createElement(FocusManager, {
          tabIndex: tabIndex
        }, function (focusRef) {
          return React.createElement("div", {
            className: classnames(className, classes.dropdown, classes['pointY-' + pointY], classes['pointX-' + pointX], showArrow && classes.withArrow, isVisible && classes.isVisible),
            style: resultStyle,
            ref: _this.getMemoizedRef(focusRef, componentRef, contentRef)
          }, children);
        });
      });
    };

    return _this;
  }

  _createClass(DropdownContent, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var closeOnClickOutside = this.props.closeOnClickOutside;
      if (!closeOnClickOutside) return this.renderContent();
      return React.createElement(OnClickOutside, {
        handler: this.onClickOutside
      }, function (componentRef) {
        return _this2.renderContent(componentRef);
      });
    }
  }]);

  return DropdownContent;
}(PureComponent);

DropdownContent.defaultProps = {
  padding: '20px',
  isVisible: false,
  closeOnClickOutside: true
};
DropdownContent.propTypes = process.env.NODE_ENV !== "production" ? {
  isVisible: PropTypes.bool,
  contentRef: PropTypes.func,
  onBecomeVisible: PropTypes.func,
  onBecomeInvisible: PropTypes.func,
  hide: PropTypes.func,
  tabIndex: PropTypes.number,
  anchorWidth: PropTypes.number,
  anchorFullWidth: PropTypes.bool,
  onRequestClose: PropTypes.func,
  closeOnClickOutside: PropTypes.bool,
  pointY: PropTypes.oneOf(POINTS_Y),
  pointX: PropTypes.oneOf(POINTS_X),
  padding: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  showArrow: PropTypes.bool,
  children: PropTypes.node
} : {};
export default withStyles(styles, {
  name: 'Dropdown'
})(DropdownContent);